import { Stack, Typography } from '@mui/material';
import './style.css';

export const CertificationLogos = ({ status }) => {

    return (
        <Stack flexDirection='row' justifyContent='space-around' alignItems='center' >
            <Stack>
                <img src='/andamio-logo.jpg' alt='Logo andamio' className='logo__bill'></img>
            </Stack>
            <Stack textAlign='center'>
                <Typography variant='h3' color='#324978'><b>ANIBER</b></Typography>
                <Typography variant='caption'>an UNE-EN-ISO 9001-2000 Certified Company</Typography>
                {
                    (possibleStatus.includes(status))
                        ? <Typography variant='subtitle1'><b>{titleEstimate}</b></Typography>
                        : <Typography variant='subtitle1'>{titleCertification}</Typography>
                }
                {
                    (possibleStatus.includes(status))
                        ? <Typography variant='caption'>{(status === 'Provisional') ? subtitleEstimate : subtitleEstimateDefinitive}</Typography>
                        : <Typography variant='h6'><b>{subtitleCertification}</b></Typography>
                }
            </Stack>
            <Stack>
                <img src='/logoPequeno.jpg' alt='Logo andamio' className='logo__certif'></img>
                <img src='/Logo-iso21.gif' alt='Logo andamio' className='logo__certif'></img>
            </Stack>
            <Stack textAlign='center'>
                <Typography variant='subtitle2'><b>ANIBER ANDAMIOS S.L.</b></Typography>
                <Typography variant='subtitle2'><b>Tel:</b> 91 591 37 10</Typography>
                <Typography variant='subtitle2'><b>Web: </b>aniber.com</Typography>
                <Typography variant='subtitle2'><b>Mail:</b> aniber@aniber.com</Typography>
                <Typography variant='subtitle2'>MADRID</Typography>
            </Stack>
        </Stack>
    )
}

const possibleStatus = ['Provisional', 'Aceptado', 'Definitivo'];
const subtitleCertification = 'CERTIFICACIÓN';
const subtitleEstimate = 'ESTE PRESUPUESTO ES PROVISIONAL HASTA COMPROBACIÓN DE DATOS EN OBRA';
const subtitleEstimateDefinitive = 'PRESUPUESTO DEFINITIVO';
const titleCertification = 'RESUMEN MENSUAL DE ANDAMIO EN ALQUILER';
const titleEstimate = 'PRESUPUESTO DE ALQUILER Y MONTAJE DE ANDAMIO';